module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADLSURBVCiRldHBbcJAEIXhf7LjVY4pwaXAGSFEBaETmwpogQ6SyNo7JaQESuAMY08OcHAcL3bebUf69EazkoqwQ6hASgbpOpZrs1N/1qgu1mYnBTmIc2ydryE0s+/+O0WtgLpRXZKieqO6GKJhUtQqRfUH5mUK9JuAenW1/Sw4hiZhDgHof9HHK2Xs9H208WmTaQnUf2Aqwi6Hnq56vbWfsQisbu0xh0bhFi5MIOb+Y6bRz0Fk02j2wL8ShI07F7kfQw4Ib/O6/Iyz/wHYgFTqwXQjRgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/edit.png
// module id = 33aG
// module chunks = 1